<template>
  <v-app :class="[getColourTheme, isHaveTempFooter]">
    <mobile-app-header class="app--toolbar"></mobile-app-header>
    <dui-snackbar
      v-model="snackOpen"
      :color="snackColor"
      :message="snackMessage"
      :classSnack="snackClass"
      :styleSnack="snackStyle"
    ></dui-snackbar>
    <nuxt :class="getNuxtClass" :nuxt-child-key="computedRouteViewKey"></nuxt>
    <dui-confirm
      ref="confirmation"
      :confirm-success-fn="$helpers.handleConfirmSuccess"
      :confirm-error-fn="$helpers.handleConfirmError"
    ></dui-confirm>
    <mobile-app-footer :menu="myMenu"></mobile-app-footer>
  </v-app>
</template>

<script>
import { get } from "lodash-es";

import MobileAppFooter from "@/components/MobileAppFooter";
import MobileAppHeader from "@/components/MobileAppHeader";

import mixinSnackbar from "@/mixins/Snackbar/mixinSnackbar";

import mixinAutomateLogout from "~/layouts/mixins/mixinAutomateLogout";
import mixinComputed from "~/layouts/mixins/mixinComputed";
import mixinCreated from "~/layouts/mixins/mixinCreated";
import mixinData from "~/layouts/mixins/mixinData";
import mixinMethods from "~/layouts/mixins/mixinMethods";
import mixinWatch from "~/layouts/mixins/mixinWatch";
import mixinWindowResize from "~/layouts/mixins/mixinWindowResize";

export default {
  name: "LayoutMobile",

  components: {
    MobileAppHeader,
    MobileAppFooter,
  },

  mixins: [
    mixinData,
    mixinCreated,
    mixinComputed,
    mixinWatch,
    mixinMethods,
    mixinAutomateLogout,
    mixinWindowResize,
    mixinSnackbar,
  ],

  computed: {
    getCreatePolicy() {
      return this.$store.getters[`products/${this.getModule}/getCreatePolicy`];
    },

    getShowDescFooter() {
      return this.$store.getters[`mobile/getShowDescFooter`];
    },

    getFooterTemplate() {
      return get(this.$store, 'getters["mobile/getFooterTemplate"]', {});
    },

    getMobileBodyHeight() {
      return get(this.$store, 'getters["mobile/getMobileBodyHeight"]', {});
    },

    getNuxtClass() {
      if (this.getCreatePolicy) {
        if (this.getMobileBodyHeight.type === "full") {
          return `page-wrapper h-100`;
        }

        if (
          this.getMobileBodyHeight.type !== "full" &&
          this.getShowDescFooter
        ) {
          return `page-wrapper h-85`;
        }

        if (
          this.getMobileBodyHeight.type !== "full" &&
          !this.getShowDescFooter
        ) {
          return `page-wrapper h-95`;
        }

        return "page-wrapper h-95";
      }
      return `page-wrapper h-95`;
    },
    isHaveTempFooter() {
      return this.getFooterTemplate.type !== "hide"
        ? "padding-temp-footer"
        : "";
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep.v-application {
  height: inherit;

  .v-application--wrap {
    height: inherit;
    width: inherit;
    padding-top: 56px;
    background-color: #f5fbff;
    overflow-y: hidden;

    .page-wrapper {
      height: inherit;
      overflow-y: auto;
      overflow-x: hidden;
      width: $tabWidth;
      margin: 0 auto;

      @media (max-width: $tabWidth) {
        width: 100%;
      }

      &::-webkit-scrollbar {
        appearance: none;
        overflow-y: auto;
      }

      &::-webkit-scrollbar:vertical {
        width: 8px;
      }

      &::-webkit-scrollbar:horizontal {
        height: 8px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgb(var(--bg-rgb), 0.6);
        border-radius: 10px;
        border: 2px solid #ffffff;
      }

      &::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: #ffffff;
      }
    }
  }

  &.padding-temp-footer > .v-application--wrap {
    padding-bottom: 56px;
  }

  &.padding-temp-footer .page-wrapper {
    padding-bottom: 0 !important;
  }
}
</style>
